import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'big-ui-spinner',
    templateUrl: './spinner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
    public readonly spinnerClass = input('flex items-center justify-center py-12');
    public readonly color = input<'primary' | 'white'>('primary');
    public readonly size = input<'m' | 's'>('m');

    public readonly computedClasses = computed(() => {
        const res = [this.spinnerClass()];
        const color = this.color();

        if(color === 'white') {
            res.push('text-white dark:text-primary');
        } else {
            res.push('text-primary dark:text-white');
        }

        return res.join(' ');
    })
}
